import React from 'react';

const SkeletonBlock = ({ className }) => (
  <div
    className={`animate-pulse rounded-xl bg-muted/70 ${className}`}
    aria-hidden="true"
  />
);

const WebHookLogFeedSkeleton = ({ groupCount = 2, cardCount = 3 }) => (
  <div className="space-y-8" aria-hidden="true">
    {Array.from({ length: groupCount }).map((_, groupIndex) => (
      <div key={`webhook-feed-skeleton-group-${groupIndex + 1}`} className="space-y-3">
        <div className="flex items-center gap-3">
          <SkeletonBlock className="h-4 w-20" />
          <SkeletonBlock className="h-px flex-1" />
          <SkeletonBlock className="h-4 w-36" />
        </div>

        {Array.from({ length: cardCount }).map((_, cardIndex) => (
          <div
            key={`webhook-feed-skeleton-card-${groupIndex + 1}-${cardIndex + 1}`}
            className="rounded-2xl border border-border/35 bg-card/25 p-4"
          >
            <div className="flex items-start gap-4">
              <SkeletonBlock className="h-11 w-11 rounded-full" />
              <div className="min-w-0 flex-1 space-y-3">
                <div className="flex flex-wrap gap-2">
                  <SkeletonBlock className="h-4 w-28" />
                  <SkeletonBlock className="h-4 w-40" />
                  <SkeletonBlock className="h-6 w-16 rounded-full" />
                </div>
                <div className="flex flex-wrap gap-3">
                  <SkeletonBlock className="h-4 w-16" />
                  <SkeletonBlock className="h-4 w-24" />
                  <SkeletonBlock className="h-4 w-20" />
                </div>
              </div>
              <div className="space-y-2 text-right">
                <SkeletonBlock className="ml-auto h-4 w-16" />
                <SkeletonBlock className="ml-auto h-7 w-24 rounded-full" />
              </div>
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default WebHookLogFeedSkeleton;
